import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AuthService } from "@services/auth.service";
import { useEffect, useState } from "react";
// import { AndroidDataEventMap } from "@declarations/event";
// import { androidLoginBiometric } from "@utils/android";
import { NoticeType } from "antd/es/message/interface";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<{ username: string; password: string }>();
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  // Auto-login biometrik dimatikan sementara, fitur belum diperlukan
  // const listener = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-login-biometric"]>) => {
  //     form.setFieldsValue(ev.data);
  //     form.submit();
  //   },
  //   [form],
  // );

  // useEffect(() => {
  //   const requestBiometric = setTimeout(() => {
  //     androidLoginBiometric();
  //   }, 500);
  //   window.addEventListener("on-login-biometric", listener);

  //   return () => {
  //     clearTimeout(requestBiometric);
  //     window.removeEventListener("on-login-biometric", listener);
  //   };
  // }, [listener]);

  const { mutate, isPending } = useMutation({
    mutationFn: AuthService.login,
    onSuccess: (response) => {
      if (response.success) {
        navigate(response.data!.redirect);
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div
        className="tw-rounded-t-[32px] tw-pt-6 tw-px-6 tw-pb-8 tw-mt-[-28px] tw-flex-1 tw-bg-background-100"
        style={{ boxShadow: "0 -4px 24px rgba(22,101,52,0.10)" }}
      >
        {/* Handle */}
        <div className="tw-flex tw-justify-center tw-mb-6">
          <div className="tw-w-10 tw-h-1 tw-rounded-full tw-bg-background-300" />
        </div>

        <div className="tw-mb-1 tw-text-xl tw-font-bold tw-text-text-primary">
          Selamat Datang
        </div>
        <div className="tw-text-sm tw-text-text-tertiary tw-mb-8">
          Masuk dengan akun santri Anda
        </div>

        <Form name="basis" layout="vertical" onFinish={(data) => mutate(data)}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "NIS tidak boleh kosong!" }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: "#166534" }} />}
              className="tw-shadow-none tw-text-sm tw-bg-background-200 tw-rounded-xl tw-border-background-300"
              style={{ height: 48 }}
              placeholder="NIS / Nomor Induk Siswa"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Password tidak boleh kosong!" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "#166534" }} />}
              className="tw-shadow-none tw-text-sm tw-bg-background-200 tw-rounded-xl tw-border-background-300"
              style={{ height: 48 }}
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item className="tw-w-full tw-mb-4 tw-mt-8">
            <Button
              className="tw-h-12 tw-w-full tw-block tw-mx-auto tw-text-sm tw-font-bold tw-text-white tw-rounded-xl tw-border-0 focus:tw-shadow-none"
              style={{ background: "#166534" }}
              htmlType="submit"
              loading={isPending}
            >
              Masuk
            </Button>
          </Form.Item>
        </Form>

        <div className="tw-mt-6 tw-text-xs tw-text-text-tertiary tw-text-center">
          Hubungi{" "}
          <span className="tw-text-primary tw-font-semibold">Admin</span> jika
          ada masalah dengan akun Anda
        </div>
      </div>
    </>
  );
};
